export default "__VITE_ASSET__Kj_wopu7__"